import React, { useState } from "react";
import { Box } from "@mui/material";
import LoginFormContent from "./LoginFormContent";
import SignupFormContent from "./SignupFormContent";
import logo from "../../assets/images/logo.svg";
import DevOpsandSRE from "../../assets/images/DevOpsandSRE.png";

export default function AuthLayout() {
  const [isLogin, setIsLogin] = useState(true);

  return (
    <Box
      sx={{
        width: "100%",
        // height: "100%",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#F5F6F8",
      }}
    >
      {/* Outer Container */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          width: { xs: "92%", sm: "80%", md: "70%", lg: "70%", xl: "70%" },
          height: { xs: "auto", sm: "auto", md: "80%", lg: "88%", xl: "80%" },
          maxHeight: { xs: "95vh", md: "none" },
          borderRadius: "1.25rem",
          border: "1px solid #E0E0E0",
          backgroundColor: "#FFF",
          gap: 3,
          overflowY: { xs: "auto", md: "hidden" },
        }}
      >
        {/* Illustration — hidden on mobile */}
        <Box
          sx={{
            width: "50%",
            borderRadius: "2rem",
            background: "transparent",
            display: { xs: "none", md: "flex" },
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={DevOpsandSRE}
            alt="Auth Illustration"
            sx={{
              width: "90%",
              height: "90%",
              objectFit: "contain",
              objectPosition: "center",
            }}
          />
        </Box>
        {/* Right Content */}
        <Box
          sx={{
            width: { xs: "100%", md: "47%", xl: "49%" },
            display: "flex",
            flexDirection: "column",
            flexShrink: 0,
            overflowY: "auto",
            height: { xs: "auto", md: "90%" },
            gap: 2,
            mt: { xs: 3, md: 5 },
            px: { xs: 3, md: 0 },
            pb: { xs: 3, md: 0 },
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {/* LOGO */}

          {/* FORM SECTION */}
          {/* <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}> */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center", // ⭐ center vertically when content is small
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="Sandhata Logo"
              sx={{
                width: "162px",
                height: "30px",
                alignSelf: "flex-start",
                mb: 2,
              }}
            />

            {isLogin ? (
              <LoginFormContent
                isLogin={isLogin}
                onSwitchToLogin={() => setIsLogin(true)}
                onSwitchToSignup={() => setIsLogin(false)}
              />
            ) : (
              <SignupFormContent
                isLogin={isLogin}
                onSwitchToLogin={() => setIsLogin(true)}
                onSwitchToSignup={() => setIsLogin(false)}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}